"use client";

import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from "react";

/** Persist is missing during SSR when localStorage is unavailable — never read it at import time. */
export function usePersistHydration(store) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== store.persist) {
    t0 = onStoreChange => store.persist?.onFinishHydration(onStoreChange) ?? _temp;
    t1 = () => store.persist?.hasHydrated() ?? false;
    $[0] = store.persist;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  return useSyncExternalStore(t0, t1, _temp2);
}
function _temp2() {
  return false;
}
function _temp() {}